module.exports = __webpack_public_path__ + "static/subset-UniNeueLight-Italic-67521b1a57a70185373fb6830a3a9053.woff";